import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {getTypes} from "../../store/types/actions";
import {fetchApp} from '../../store/apps/actions';
import style from '../../styles/styles';
import styles from './EditNewsPage.css';
import {fetchOneNews, putOneNews} from "../../store/news/actions";
import NewsForm from "../../components/news/NewsForm";
import {NEWS_PAGE} from "../../constants/routes";
import withTranslation from "../../hoc/withTranslation";
import {getCustomFields} from "../../store/customfields/actions";
import CustomFieldService from "../../services/customfield";

export class EditNewsPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    componentDidMount() {
        this.fetch();
        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.lang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            let url = NEWS_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':newsId', this.props.news.id);
            this.props.history.push(url);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.lang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    // Fetch

    fetch(appId = null, newsId = null) {
        this.fetchApplication(appId);
        this.fetchOneNews(appId, newsId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchOneNews(appId = null, newsId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const news = newsId || this.props.match.params.newsId;

            if (app && news) {
                this.props.fetchOneNews(app, news, this.props.lang)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putOneNews(this.props.app.id, formProps, this.props.lang);
    };

    handleFormReset = () => {
        if (this.props.news) {
            //TODO : reset news
        }
    };

    // Render

    renderForm() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.news.title}</Subheader>
                    <div style={style.paper}>
                        <NewsForm
                            customFields={
                                CustomFieldService.filter(
                                    this.props.customFields,
                                    CustomFieldService.NEWS
                                )
                            }
                            onFormReset={this.handleFormReset}
                            onSubmit={this.handleFormSubmit}
                            initialValues={this.props.initialValues}
                            submitting={this.props.sending}
                            news={this.props.news}
                            enableReinitialize={true}
                            types={this.props.types}
                        />
                    </div>
                    <div style={style.clear}/>
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.news) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('module.news.news_edit')}</h3>
                    <div className="row">
                        {this.renderForm()}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.news.pending || state.types.pending || state.customFields.pending,
        error: state.news.error || state.apps.error,
        news: state.news.currentNews,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        types: state.types.content,
        sending: state.news.sending,
        customFields: state.customFields.content
    };

    const news = state.news.currentNews;

    if (news) {
        let initValues = {...news};

        if (news.custom_fields) {
            news.custom_fields.forEach((cf) => {
                initValues[cf.id] = cf.value;
            })
        }
        props.initialValues = initValues;
    }

    return props;
}

export default connect(mapStateToProps, {
    getTypes,
    putOneNews,
    getCustomFields,
    fetchApp,
    fetchOneNews
})(withTranslation(EditNewsPage));



// WEBPACK FOOTER //
// src/containers/news/EditNewsPage.js